import React from 'react';
import '../styles/FormField.css';

const FormField = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  error,
  disabled = false,
  options = [], // Pour select
  className = '',
  icon,
  help,
  rows = 3, // Pour textarea
  ...props
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value, name, e);
    }
  };

  const renderInput = () => {
    const baseProps = {
      id: name,
      name,
      value: value || '',
      onChange: handleChange,
      placeholder,
      required,
      disabled,
      className: `form-input ${error ? 'error' : ''} ${icon ? 'with-icon' : ''}`,
      ...props
    };

    switch (type) {
      case 'textarea':
        return <textarea {...baseProps} rows={rows} />;
      
      case 'select':
        return (
          <select {...baseProps}>
            {placeholder && (
              <option value="" disabled>
                {placeholder}
              </option>
            )}
            {options.map((option) => (
              <option 
                key={option.value || option} 
                value={option.value || option}
                disabled={option.disabled}
              >
                {option.label || option}
              </option>
            ))}
          </select>
        );
      
      case 'checkbox':
        return (
          <div className="checkbox-wrapper">
            <input
              {...baseProps}
              type="checkbox"
              checked={value || false}
              onChange={(e) => onChange && onChange(e.target.checked, name, e)}
              className="form-checkbox"
            />
            <span className="checkbox-label">{label}</span>
          </div>
        );
      
      case 'radio':
        return (
          <div className="radio-group">
            {options.map((option) => (
              <label key={option.value || option} className="radio-wrapper">
                <input
                  type="radio"
                  name={name}
                  value={option.value || option}
                  checked={value === (option.value || option)}
                  onChange={handleChange}
                  disabled={disabled}
                  className="form-radio"
                />
                <span className="radio-label">{option.label || option}</span>
              </label>
            ))}
          </div>
        );
      
      default:
        return <input {...baseProps} type={type} />;
    }
  };

  if (type === 'checkbox') {
    return (
      <div className={`form-field ${className}`}>
        {renderInput()}
        {error && <div className="field-error">{error}</div>}
        {help && <div className="field-help">{help}</div>}
      </div>
    );
  }

  return (
    <div className={`form-field ${className}`}>
      {label && (
        <label htmlFor={name} className="field-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      
      <div className="input-wrapper">
        {icon && <div className="input-icon">{icon}</div>}
        {renderInput()}
      </div>
      
      {error && <div className="field-error">{error}</div>}
      {help && <div className="field-help">{help}</div>}
    </div>
  );
};

export default FormField;